import { useState } from "react";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    Container,
} from "reactstrap";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import "./CourseFAQ.css";


const CourseFAQ = ({
    courseName = "Course",
    faqs = [],
}) => {

    const [open, setOpen] = useState("");

    const toggle = (id) => {
        setOpen(open === id ? "" : id);
    };

    if (!faqs || faqs.length === 0) {
        return null;
    }

    return (
        <section className="course-faq-section">

            <Container fluid>

                {/* =========================================
                    HEADER
                ========================================= */}

                <div className="course-faq-header">

                    <div className="course-faq-badge">
                        <QuestionMarkIcon />
                        FREQUENTLY ASKED QUESTIONS
                    </div>

                    <h2>
                        Frequently Asked{" "}
                        <strong>Questions</strong>
                    </h2>

                    <p>
                        Find answers to common questions about our{" "}
                        {courseName} course, learning process,
                        projects, support, and career opportunities.
                    </p>

                </div>


                {/* =========================================
                    FAQ ACCORDION
                ========================================= */}

                <div className="course-faq-container">

                    <Accordion
                        flush
                        open={open}
                        toggle={toggle}
                    >

                        {faqs.map((faq, index) => {

                            const faqId = String(faq.id || index + 1);

                            return (

                                <AccordionItem
                                    key={faqId}
                                    className={
                                        open === faqId
                                            ? "course-faq-item course-faq-item-open"
                                            : "course-faq-item"
                                    }
                                >

                                    <AccordionHeader
                                        targetId={faqId}
                                    >

                                        <div className="course-faq-question">

                                            <span className="course-faq-number">
                                                {String(index + 1).padStart(
                                                    2,
                                                    "0"
                                                )}
                                            </span>

                                            <span className="course-faq-question-text">
                                                {faq.question}
                                            </span>

                                        </div>

                                    </AccordionHeader>


                                    <AccordionBody
                                        accordionId={faqId}
                                    >

                                        <div className="course-faq-answer">

                                            {faq.answer && (
                                                <p>
                                                    {faq.answer}
                                                </p>
                                            )}


                                            {/* =================================
                                                ANSWER LIST
                                            ================================= */}

                                            {faq.list && faq.list.length > 0 && (

                                                <ul className="course-faq-list">

                                                    {faq.list.map(
                                                        (item, itemIndex) => (

                                                            <li key={itemIndex}>
                                                                <span className="faq-list-dot" />
                                                                <span>
                                                                    {item}
                                                                </span>
                                                            </li>

                                                        )
                                                    )}

                                                </ul>

                                            )}


                                            {/* =================================
                                                ADDITIONAL CONTENT
                                            ================================= */}

                                            {faq.content && (
                                                <div className="course-faq-extra">
                                                    {faq.content}
                                                </div>
                                            )}


                                            {/* =================================
                                                LINK
                                            ================================= */}

                                            {faq.link && (

                                                <a
                                                    href={faq.link.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="course-faq-link"
                                                >
                                                    {faq.link.text}

                                                    <ArrowForwardIcon />

                                                </a>

                                            )}

                                        </div>

                                    </AccordionBody>

                                </AccordionItem>

                            );
                        })}

                    </Accordion>

                </div>

            </Container>

        </section>
    );
};


export default CourseFAQ;